import React, { useEffect } from 'react';
import { Button } from '../components/ui/Button';
import { useDrawers } from '../contexts/DrawerContext';
import { Phone, Mail, MapPin, Clock, FileText } from 'lucide-react';
export function Contact() {
  const {
    openUpload,
    openQuote
  } = useDrawers();
  useEffect(() => {
    document.title = 'Contact L.A Property Law | Australia';
    window.scrollTo(0, 0);
  }, []);
  return <main data-id="element-591" data-mp="y05yde5ds89t">
      <section className="px-5 md:px-6 py-8 md:py-10 bg-background" data-id="element-592" data-mp="xzw7zpgfbz3l">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-6 lg:gap-8 items-start" data-id="element-593" data-mp="t1mcfdqsewhg">
          <div data-id="element-594" data-mp="szrorro4sq9o">
            <p className="eyebrow text-brand-blue mb-1" data-id="element-595" data-mp="17q8qlc4ohi73">
              get in touch
            </p>
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-ink leading-[1.08]" data-id="element-596" data-mp="13022dde2vzpd">
              Tell us about your property matter.
            </h1>
            <p className="mt-5 text-lg text-muted-ink leading-relaxed max-w-xl" data-id="element-597" data-mp="f83d1phso3t8">
              Send your contract for review or request a quote. Include any
              auction, offer or signing deadline so the team can assess how
              quickly your matter needs to move.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3" data-id="element-598" data-mp="19exnqp2mse7w">
              <Button onClick={openUpload} variant="accent" size="lg" data-id="element-599" data-mp="1e91w9crjoub3">
                <FileText className="w-5 h-5" data-id="element-600" data-mp="1j7d6holr56tu" />
                Upload a contract
              </Button>
              <Button onClick={openQuote} variant="outline" size="lg" data-id="element-601" data-mp="mh2wefba97d6">
                Get a free quote
              </Button>
            </div>
          </div>

          <div data-id="element-602" data-mp="qk8z5cz6sgew">
            <div className="rounded-2xl bg-surface border border-border p-5 md:p-6" data-id="element-603" data-mp="vh941kkavd4f">
              <h2 className="font-serif text-2xl text-ink mb-6" data-id="element-604" data-mp="vjlt0hoh6nqz">
                L.A Property Law & Conveyancing
              </h2>
              <ul className="space-y-5" data-id="element-605" data-mp="26wxred1gue5r">
                <li className="flex items-start gap-4" data-id="element-606" data-mp="26w65xv1l1wt7">
                  <span className="shrink-0 inline-flex items-center justify-center w-10 h-10 rounded-full bg-accent-soft text-accent" data-id="element-607" data-mp="2buzhvj181fr9">
                    <MapPin className="w-5 h-5" data-id="element-608" data-mp="1m5shxqg6g0j3" />
                  </span>
                  <div data-id="element-609" data-mp="1h78u1ki0weo3">
                    <p className="text-ink font-medium" data-id="element-610" data-mp="1h7qwwzz6xr4z">
                      202 Elgin Street, Carlton VIC 3053, Australia
                    </p>
                    <a href="https://maps.google.com/?q=202+Elgin+Street+Carlton+VIC+3053" target="_blank" rel="noopener noreferrer" className="text-brand-blue font-semibold hover:underline" data-id="element-611" data-mp="1r6pzq1x9ysk2">
                      View on Google Maps
                    </a>
                  </div>
                </li>
                <li className="flex items-start gap-4" data-id="element-612" data-mp="18ffcpvuo6zxg">
                  <span className="shrink-0 inline-flex items-center justify-center w-10 h-10 rounded-full bg-accent-soft text-accent" data-id="element-613" data-mp="18dvtbwdpw8rg">
                    <Phone className="w-5 h-5" data-id="element-614" data-mp="frt8qmhj5ta2" />
                  </span>
                  <a href="tel:+61386172600" className="text-ink font-medium hover:text-accent transition-colors" data-id="element-615" data-mp="fpgou3s7p8ud">
                    (03) 8617 2600
                  </a>
                </li>
                <li className="flex items-start gap-4" data-id="element-616" data-mp="2hhs0xm9466f9">
                  <span className="shrink-0 inline-flex items-center justify-center w-10 h-10 rounded-full bg-accent-soft text-accent" data-id="element-617" data-mp="2mfjusltbk2m3">
                    <Mail className="w-5 h-5" data-id="element-618" data-mp="3a660w7jrjctg" />
                  </span>
                  <a href="mailto:hello@lapropertylaw.com.au" className="text-ink font-medium hover:text-accent transition-colors break-all" data-id="element-619" data-mp="3f3z893wsycvb">
                    hello@lapropertylaw.com.au
                  </a>
                </li>
                <li className="flex items-start gap-4" data-id="element-620" data-mp="1ppj6enwv3o5b">
                  <span className="shrink-0 inline-flex items-center justify-center w-10 h-10 rounded-full bg-accent-soft text-accent" data-id="element-621" data-mp="1pnq0xbxzj9yw">
                    <Clock className="w-5 h-5" data-id="element-622" data-mp="29y0we7mebfq7" />
                  </span>
                  <div className="text-ink" data-id="element-623" data-mp="2a03vri9ful7l">
                    <p className="font-medium" data-id="element-624" data-mp="256slf75f3max">Mon-Fri 9:00am-5:00pm</p>
                    <p className="text-muted-ink text-sm mt-0.5" data-id="element-625" data-mp="2087kf5iccylf">
                      Office visits by appointment only
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </main>;
}